export default "__VITE_ASSET__B_g0$c8e__"